import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { toast } from 'react-hot-toast'

const GoogleCallback = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const auth = useAuth()

  useEffect(() => {
    const handleGoogleCallback = async () => {
      const code = searchParams.get('code')
      const error = searchParams.get('error')

      if (error) {
        console.error('[GOOGLE CALLBACK] Error:', error)
        toast.error('فشل المصادقة عبر Google')
        navigate('/login')
        return
      }

      if (!code) {
        console.error('[GOOGLE CALLBACK] No authorization code received')
        toast.error('فشل المصادقة عبر Google')
        navigate('/login')
        return
      }

      try {
        console.log('[GOOGLE CALLBACK] Processing authorization code:', code)
        
        // Send the authorization code to your backend
        const response = await fetch(`${import.meta.env.VITE_API_URL || 'http://localhost:3004'}/api/auth/google/callback`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ code })
        })

        const data = await response.json()

        if (response.ok) {
          // Store the token and update auth state
          localStorage.setItem('token', data.token)
          
          // Force a page reload to refresh the auth state
          toast.success(`مرحباً${data.user.name ? `, ${data.user.name}` : ''}!`)
          window.location.href = '/' // Use window.location.href instead of navigate
        } else {
          console.error('[GOOGLE CALLBACK] Backend error:', data)
          toast.error(data.message || 'فشل المصادقة عبر Google')
          navigate('/login')
        }
      } catch (error) {
        console.error('[GOOGLE CALLBACK] Network error:', error)
        toast.error('خطأ في الشبكة أثناء المصادقة')
        navigate('/login')
      }
    }

    handleGoogleCallback()
  }, [searchParams, navigate, auth])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">جاري إكمال تسجيل الدخول عبر Google...</p>
      </div>
    </div>
  )
}

export default GoogleCallback
